module.exports = __webpack_public_path__ + "media/images/prize__saint-brakes-a36bf9b80dc415e6aac9b3aac267edcc.jpg";